import React from 'react';
import { Grid, Card } from 'semantic-ui-react';
import { ExtendedDocuments } from '../Documents';
import FNButtons from './FNButtons';

const Summary = ({ navButtonsProps, documentType, onNext, ...rest }) => {
  const { selectedPassengers, ...restProps } = rest;
  return (
    <React.Fragment>
      <Card.Description>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <ExtendedDocuments
                filterTypes={documentType}
                editDisabled
                onlyOneDocument
                refetch={5000}
                {...restProps}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Description>
      <FNButtons {...navButtonsProps} onNext={onNext} />
    </React.Fragment>
  );
};

export default Summary;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/Summary.js